<div class="flex-fill d-flex" [ngClass]="readOnly ? '' : ' flex-column'">
  <div class="flex-fill content-block dx-card row" [ngClass]="readOnly ? '' : ' responsive-paddings'">
    <div class="d-flex flex-column p-3">
      <h4 class="ms-1 mb-0">Dispatch Notes</h4>
      <dx-data-grid
        #dataGrid
        keyExpr="id"
        class="{{!readOnly ? 'h-100' : 'readOnly-height'}}"
        [dataSource]="dispatchNotes"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowPrepared)="onRowPrepared($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        >
        <dxi-data-grid-column dataField="companyName" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="siteName" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="rentalDate" width="125"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="created" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="createdBy" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="completed" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="notAwarded" width="150"></dxi-data-grid-column>

        <dxo-data-grid-selection [mode]="'multiple'"></dxo-data-grid-selection>
        <dxo-data-grid-search-panel [visible]="!readOnly"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <!-- <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export> -->
        <dxo-data-grid-state-storing
          [enabled]="true"
          type="localStorage"
          storageKey="{{!readOnly ? 'dispatch-notes-overview-grid' : 'rental-dispatch-notes-overview-grid'}}"
        ></dxo-data-grid-state-storing>

        <div *dxTemplate="let data of 'toolbarButtons'">
          <button class="btn btn-success me-1 mb-2" (click)="add()" [hidden]="readOnly">Add Note</button>
          <button
            class="btn btn-danger me-2 mb-2"
            (click)="delete(dataGrid.instance.getSelectedRowsData())"
            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
            [hidden]="readOnly"
            >
            Delete
          </button>
          <button
            class="btn btn-primary ms-3 me-1 mb-2"
            (click)="createRental()"
            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || canCreateRental"
            [hidden]="readOnly"
            >
            Create Rental
          </button>
          <button
            class="btn btn-secondary ms-3 me-1 mb-2"
            (click)="markComplete()"
            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || canCreateRental"
            [hidden]="readOnly"
            >
            Mark Complete
          </button>
          <button class="btn btn-secondary mb-2 me-3" (click)="unComplete()" [disabled]="!canUnComplete" [hidden]="readOnly">
            UnComplete
          </button>
          <button class="btn btn-sm btn-warning mb-2" (click)="toggleHideCompleted()" [hidden]="readOnly">
            {{ hideCompleted ? 'Show All' : 'Hide Completed' }}
          </button>
        </div>
      </dx-data-grid>
    </div>
    <div class="d-flex flex-fill flex-column p-3">
      <div class="mb-2">
        @if (hasChanges()) {
          <button class="btn btn-success me-1" (click)="save()">Save</button>
        }
        @if (hasChanges()) {
          <button class="btn btn-danger me-3" (click)="cancel()">Cancel</button>
        }
        <button class="btn btn-primary" (click)="saveAsLost()" [disabled]="selectedDispatchNote.notAwarded">Save As Lost</button>
      </div>
      <h4 class="header-label mb-2">Note</h4>
      @if (selectedDispatchNote) {
        <app-dispatch-notes-detail
          style="display: block; padding-top: 1rem"
          [dispatchNote]="selectedDispatchNote"
          [readOnly]="!!selectedDispatchNote.completed"
        ></app-dispatch-notes-detail>
      }
    </div>
  </div>
</div>
